// 智慧巡更
import Log from "../view/log";
import PatrolPointAdd from "../view/KeepWatch/PatrolPointManage/PatrolPointAdd";
import PatrolPointModify from "../view/KeepWatch/PatrolPointManage/PatrolPointModify";
import PatrolPointManage from "../view/KeepWatch/PatrolPointManage/PatrolPointManage";
import TeamAdd from "../view/KeepWatch/TeamManage/TeamAdd";
import TeamModify from "../view/KeepWatch/TeamManage/TeamModify";
import TeamManage from "../view/KeepWatch/TeamManage/TeamManage";
import PatrolRouteAdd from "../view/KeepWatch/PatrolRoute/PatrolRouteAdd";
import PatrolRouteModify from "../view/KeepWatch/PatrolRoute/PatrolRouteModify";
import PatrolRouteManage from "../view/KeepWatch/PatrolRoute/PatrolRouteManage";
import WorkforceAdd from "../view/KeepWatch/WorkforceManage/WorkforceAdd";
import WorkforceModify from "../view/KeepWatch/WorkforceManage/WorkforceModify";
import WorkforceManage from "../view/KeepWatch/WorkforceManage/WorkforceManage";
import KeepWatchRecord from "../view/KeepWatch/KeepWatchRecord/KeepWatchRecord";
import PatrolTask from "../view/KeepWatch/PatrolTask/PatrolTask";
import PatrolReport from "../view/KeepWatch/PatrolReport/PatrolReport";
import KeepWatchNav from "../view/KeepWatch/KeepWatchNav";

export default [
  /* 智慧巡更 */
  {
    path: "/patrol_point_manage",
    name: "patrol-point-manage",
    components: {
      default: KeepWatchNav,
      a: PatrolPointManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/patrol_point_add",
    name: "patrol-point-add",
    components: {
      default: KeepWatchNav,
      a: PatrolPointAdd
    }
  },
  {
    path: "/patrol_point_modify/:id",
    name: "patrol-point-modify",
    components: {
      default: KeepWatchNav,
      a: PatrolPointModify
    }
  },
  {
    path: "/team_manage",
    name: "team-manage",
    components: {
      default: KeepWatchNav,
      a: TeamManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/team_add",
    name: "team-add",
    components: {
      default: KeepWatchNav,
      a: TeamAdd
    }
  },
  {
    path: "/team_modify/:id",
    name: "team-modify",
    components: {
      default: KeepWatchNav,
      a: TeamModify
    }
  },
  {
    path: "/patrol_route_manage",
    name: "patrol-route-manage",
    components: {
      default: KeepWatchNav,
      a: PatrolRouteManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/patrol_route_add",
    name: "patrol-route-add",
    components: {
      default: KeepWatchNav,
      a: PatrolRouteAdd
    }
  },
  {
    path: "/patrol_route_modify/:id",
    name: "patrol-route-modify",
    components: {
      default: KeepWatchNav,
      a: PatrolRouteModify
    }
  },
  {
    path: "/workforce_manage",
    name: "workforce-manage",
    components: {
      default: KeepWatchNav,
      a: WorkforceManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/workforce_add",
    name: "workforce-add",
    components: {
      default: KeepWatchNav,
      a: WorkforceAdd
    }
  },
  {
    path: "/workforce_modify/:id",
    name: "workforce-modify",
    components: {
      default: KeepWatchNav,
      a: WorkforceModify
    }
  },
  {
    path: "/keep_watch_record",
    name: "keep-watch-record",
    components: {
      default: KeepWatchNav,
      a: KeepWatchRecord
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/patrol_task",
    name: "patrol-task",
    components: {
      default: KeepWatchNav,
      a: PatrolTask
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/patrol_report",
    name: "patrol-report",
    components: {
      default: KeepWatchNav,
      a: PatrolReport
    },
    meta: {
      keepAlive: true
    }
  },
  /* 智慧巡更 */

  // 智慧巡更操作日志
  {
    path: "/keep_watch_log",
    name: "keep-watch-log",
    components: {
      default: KeepWatchNav,
      a: Log
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/KeepWatch.js